
import { ShieldCheck, Timer } from "lucide-react";
import React from "react";
import Card from "../ui/Card";
import Container from "../ui/Container";
import SectionTitle from "../ui/SectionTitle";

const ticketChecklist = [
  "Service or node name from your dashboard",
  "What you expected to happen vs. what you saw",
  "Any error messages or screenshots",
  "Recent changes (mods, plugins, or config edits)",
];

const responseTimes = [
  {
    title: "Critical incidents",
    description: "Immediate triage for outages impacting multiple customers.",
    metric: "15 min",
  },
  {
    title: "Game hosting questions",
    description: "Configuration help and performance tuning advice.",
    metric: "1-2 hrs",
  },
  {
    title: "Billing & account",
    description: "Invoices, refunds, or account verification requests.",
    metric: "Same day",
  },
];


export default function SupportReady() {
    return (
        <section className="bg-[#070A0F] pb-24 pt-10">
            <Container>
                <div className="grid gap-10 lg:grid-cols-[1.1fr_0.9fr]">
                    <div>
                        <SectionTitle
                            eyebrow="TICKET READY"
                            title="Help us help you"
                            subtitle="Share the details below and we can resolve most issues on the first reply."
                        />
                        <div className="mt-8 space-y-4">
                            {ticketChecklist.map((item) => (
                                <div key={item} className="flex items-start gap-3 text-sm text-white/70">
                                    <span className="mt-1 inline-flex h-5 w-5 items-center justify-center rounded-full bg-cyan-300/20 text-cyan-300">
                                        <ShieldCheck className="h-3 w-3" />
                                    </span>
                                    <span>{item}</span>
                                </div>
                            ))}
                        </div>
                    </div>
                    <Card className="p-8">
                        <div className="flex items-center gap-3 text-sm font-semibold text-white/80">
                            <Timer className="h-4 w-4 text-cyan-300" />
                            Typical response times
                        </div>
                        <div className="mt-6 space-y-5">
                            {responseTimes.map((item) => (
                                <div key={item.title} className="flex items-start justify-between gap-4">
                                    <div>
                                        <div className="text-sm font-semibold text-white">{item.title}</div>
                                        <div className="mt-1 text-sm text-white/60">{item.description}</div>
                                    </div>
                                    <div className="rounded-full border border-white/10 bg-white/5 px-3 py-1 text-xs text-white/70">
                                        {item.metric}
                                    </div>
                                </div>
                            ))}
                        </div>
                    </Card>
                </div>
            </Container>
        </section>
    )
}